export function convertQuillHtmlToInlineAndClassHtml(html) {
  const container = document.createElement('div');
  container.innerHTML = html;

  const fontClassToFamily = {
    'ql-font-monospace': 'monospace',
    'ql-font-montserrat': 'montserrat',
    'ql-font-roboto': 'roboto',
    'ql-font-arial': 'arial',
    'ql-font-serif': 'serif',
  };

  const sizeClassToPx = {
    'ql-size-6px': '6px',
    'ql-size-8px': '8px',
    'ql-size-12px': '12px',
    'ql-size-16px': '16px',
    'ql-size-18px': '18px',
    'ql-size-24px': '24px',
  };

  function processElement(el) {
    if (el.nodeType !== Node.ELEMENT_NODE) return;

    const tagName = el.tagName.toUpperCase();
    const classes = Array.from(el.classList);
    const styleMap = new Map();

    // Handle font classes
    classes.forEach((cls) => {
      if (fontClassToFamily[cls]) {
        styleMap.set('font-family', fontClassToFamily[cls]);
      }
      if (sizeClassToPx[cls]) {
        styleMap.set('font-size', sizeClassToPx[cls]);
      }
    });

    // Apply font size from child span to <li> itself
    if (tagName === 'LI' && !styleMap.has('font-size')) {
      const spanWithSize = el.querySelector('[class*="ql-size-"]');
      if (spanWithSize) {
        const spanClasses = Array.from(spanWithSize.classList);
        spanClasses.forEach((cls) => {
          if (sizeClassToPx[cls]) {
            styleMap.set('font-size', sizeClassToPx[cls]);
          }
        });
      }
    }

    // Handle OL styling
    if (tagName === 'OL') {
      styleMap.set('list-style-type', 'decimal');
      styleMap.set('padding-left', '20px');
    }

    // Handle LI in OL with data-list="bullet"
    if (
      tagName === 'LI' &&
      el.getAttribute('data-list') === 'bullet' &&
      el.parentElement?.tagName.toUpperCase() === 'OL'
    ) {
      styleMap.set('list-style-type', 'disc');
    }

    // Preserve existing inline styles
    const inlineStyle = el.getAttribute('style') || '';
    const newStyleParts = [...styleMap.entries()].map(
      ([key, val]) => `${key}:${val}`
    );
    const finalStyle = [...newStyleParts, inlineStyle]
      .filter(Boolean)
      .join('; ');

    if (finalStyle) {
      el.setAttribute('style', finalStyle);
    }
  }

  const walk = (node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      processElement(node);
      node.childNodes.forEach(walk);
    }
  };

  container.childNodes.forEach(walk);

  // remove cursor
  const htmlString = container.innerHTML;
  const cleaned = htmlString.replace(
    /<span class="ql-cursor">.*?<\/span>/g,
    ''
  );

  return cleaned;
}
